import { render, staticRenderFns } from "./activeUser.vue?vue&type=template&id=b5b2f4d2&scoped=true"
import script from "./activeUser.vue?vue&type=script&lang=js"
export * from "./activeUser.vue?vue&type=script&lang=js"
import style0 from "./activeUser.vue?vue&type=style&index=0&id=b5b2f4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b2f4d2",
  null
  
)

export default component.exports